import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { EncerramentoContabilFormComponent } from './encerramento-contabil-form/encerramento-contabil-form.component';

const routes: Routes = [
  { path: 'novo', component: EncerramentoContabilFormComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EncerramentoContabilRoutingModule { }
